exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.ui.modal{\n  top: 40% !important;\n\n}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/demand/new-demand/new-demand.component.css
// module id = ../../../../../src/app/_components/demand/new-demand/new-demand.component.css
// module chunks = main